/**
 * CommentHeader
 */

import Config from '../../Config';
import Util from '../../Util';

export const COMMENT_TITLE = 'comment-title';

export const COMMENT_ANCHOR = 'comment';

export const COMMENT_HEADER = 'comment-header';

class CommentHeader {

	private $parent: any;

	private _id: string;

	private articleId: string;

	constructor( $parent: any, articleId: string /*, callback*/ ) {
		this.$parent = $parent;
		this._id = this.$parent.attr( 'id' );
		this.articleId = articleId;
		// this.callback = callback;
	}

	public setUI( data: any ) {
		const header = this.template( data );
		return header;
	}

	public getCommentCount() {
		const count = parseInt( jQuery( `#${this._id} .commentTotalCount` ).text(), 10 );

		if ( count ) {
			return count;
		}

		return 0;
	}

	public setCommentCount( totalCount: string|number ) {
        const t = this.numberWithCommas(totalCount);
        jQuery( `#${this._id} .commentTotalCount` ).text( t );
	}

    public numberWithCommas(x: string|number ) {
        let parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    }

	private template( data: any ) {
		return Util.Tmpl.render({
			data,
			template: ( _v: any ) => `
				<div class="${COMMENT_HEADER}">
					<h3 class="comment-title">
					<a href="#${Config.COMMENT_ANCHOR_NAME}" name="${Config.COMMENT_ANCHOR_NAME}">${Config.L10N.comment}</a>
					<span class="commentTotalCount">${this.numberWithCommas( ( ( _v && _v.totalCount ) ? _v.totalCount : 0 ) + ( ( _v && _v.replyCount ) ? _v.replyCount : 0 ) )}
					</span></h3>
				</div>`,
		});
	}
}

export default CommentHeader;
